export const sectionConfig = {
    added: { label: 'Added' },
    improved: { label: 'Improved' },
    fixed: { label: 'Fixed' },
};

export const platformColors = {
    Web: { bg: '#F4F3FF', color: '#5925DC' },
    Mobile: { bg: '#EFF8FF', color: '#175CD3' },
    API: { bg: '#F4F3FF', color: '#7B61EA' },
};

export const ACTION_TYPE = 'GET_PUBLISHED_VERSIONS'